import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Button, theme, Grid, Row, Flex, Spin } from 'antd';
import OtpInput from 'react-otp-input';
import _ from 'lodash';

import config from '../../config';
import LocalStorageHelper from '../../helpers/local_storage';
import AuthHelper from '../../helpers/auth';
import sengLogo from '../../images/seng-logo.svg';
import background from '../../images/auth-background.webp';

const { Text, Link } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const SignUpVerificationPage = (props) => {
	const { token } = useToken();
	const screens = useBreakpoint();
	const history = useHistory();
	const user = LocalStorageHelper.getSignUpUser();
	const email = user.email;

	const { requestSignUpOtp, verifySignUpOtp, resetPage, resetMeta, signUpPageProps, loginPageProps } = props;
	const { loadingRequestSubmit, loadingVerifySubmit, meta } = signUpPageProps;
	const { event } = loginPageProps;

	// States
	const [disabled, setDisabled] = useState(true);
	const [otp, setOtp] = useState('');
	const [errMsg, setErrMsg] = useState(null);

	// Functions
	const handleverifyAuthOtp = () => {
		verifySignUpOtp({ email, otp });
	};

	const handlerequestAuthOtp = () => {
		requestSignUpOtp({ email, lastName: user.last_name, firstName: user.first_name, resend: true });
	};

	useEffect(() => {
		// Check if already logged in
		const authenticated =  AuthHelper.isAuthenticated();
		if (authenticated) {
			history.push('/application');
		}

		if (!email) {
			history.push('/login');
		}

		return () => {
			resetPage();
			resetMeta();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (otp.length === 6) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	}, [otp]);

	useEffect(() => {
		if (meta && meta.code !== 200) {
			const message = meta.message;
			setErrMsg(message);
		} else {
			setErrMsg(null);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	// Fix for loading background image
	if (!event) {
		return (
			<Flex
				justify="center"
				align="center"
				style={{ height: '100vh' }}
			>
				<Spin/>
			</Flex>
		);
	}

	return (
		<div
			style={{
				background: `url(${_.get(event, 'image_asset_id') ?
					`${config.api}/public/assets/events/published` : background})`,
				backgroundSize: 'cover',
				height: '100vh'
			}}
		>
			<div
				style={{
					height: screens.xs ? '80vh' : '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<Flex
					vertical
					style={{
						width: 535,
						backgroundColor: token.whiteColor,
						borderRadius: 20,
						padding: screens.xs ? 20 : '48px 41px'
					}}
				>
					<Flex
						justify="center"
						style={{ alignSelf: 'center', maxHeight: 56, marginBottom: 30 }}
					>
						<img
							src={sengLogo}
							alt="seng-logo"
							style={screens.xs ? { width: '100%' } : { height: '100%' }}
						/>
					</Flex>
					<Text
						style={{
							fontSize: 32,
							color: token.colorPrimary,
							fontWeight: 110,
							lineHeight: 1
						}}
					>
						{event ? event.name : 'HKUST Engineering Summer Camp Online Application System'}
					</Text>
					<div style={{ marginTop: 25, marginBottom: 45 }}>
						<Text style={{ fontSize: 16 }}>
							To start with the account creation, enter the code we just emailed to {email}.
						</Text>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center'
							}}
						>
							<Text
								strong
								style={{ fontSize: 19, color: token.colorPrimary, margin: 10 }}
							>
								Enter the 6-digit Code
							</Text>
							<Row
								style={{ maxWidth: 272 }}
							>
								<OtpInput
									value={otp}
									onChange={setOtp}
									numInputs={6}
									renderInput={(props) => <input {...props} />}
									inputType="tel"
									shouldAutoFocus={true}
									containerStyle={{
										display: 'flex',
										gap: 10
									}}
									inputStyle={{
										height: 48,
										width: 37,
										border: '1px solid #D9D9D9',
										borderRadius: 8
									}}
								/>
							</Row>
							{errMsg && <Text type="danger">{errMsg}</Text>}
						</div>
					</div>
					<div>
						<Button
							type="primary"
							size="large"
							disabled={disabled}
							loading={loadingVerifySubmit}
							style={{ width: '100%', borderRadius: 50, height: 56 }}
							onClick={handleverifyAuthOtp}
						>
							Submit
						</Button>
					</div>
					<div style={{ marginTop: 12 }}>
						<Text style={{ fontSize: 16 }}>Did not receive code? </Text>
						<Link
							style={{ fontSize: 16 }}
							onClick={handlerequestAuthOtp}
						>
							{loadingRequestSubmit ? 'Sending...' : 'Send again'}
						</Link>
					</div>
				</Flex>
			</div>
		</div>
	);
};

export default SignUpVerificationPage;